import { Card, CardContent, Typography, Box } from "@mui/material";
import AlertIcon from "./img/alert.svg";
import ArrowIcon from "./img/arrow.svg";
import CheckMarkIcon from "./img/checkMark.svg";
import ClockIcon from "./img/clock.svg";
import InfoIcon from "./img/info.svg";
import StarIcon from "./img/star.svg";

export default function ServiceAnnouncementPreview({
  icon,
  title,
  titleColor,
  content,
}) {
  return (
    <Card
      sx={{
        display: "flex",
        alignItems: "flex-start",
        padding: 2,
        borderRadius: "13px",
        boxShadow: "0px 4px 4px 0px #00000040",
        maxWidth: 400,
      }}
    >
      {/* Icon */}
      <Box sx={{ marginRight: 2 }}>
        {icon && getIcon(icon)}
      </Box>

      {/* Text Content */}
      <CardContent sx={{ padding: 0, "&:last-child": { paddingBottom: 0 } }}>
        <Typography
          sx={{
            fontWeight: 500,
            color: titleColor || "black",
            fontFamily: "Inter",
            marginBottom: 0,
            lineHeight: 1.2,
          }}
        >
          {title || "Title goes here"}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ marginBottom: 0, lineHeight: 1.3 }}
        >
          {content || "Content goes here"}
        </Typography>
      </CardContent>
    </Card>
  );
}

const getIcon = (iconKey) => {
  let src;
  switch (iconKey) {
    case "alert":
      src = AlertIcon;
      break;
    case "arrow":
      src = ArrowIcon;
      break;
    case "checkMark":
      src = CheckMarkIcon;
      break;
    case "clock":
      src = ClockIcon;
      break;
    case "info":
      src = InfoIcon;
      break;
    case "star":
      src = StarIcon;
      break;
    default:
      return null;
  }

  return <img src={src} width={30} height={30} alt={iconKey} />;
};
